import React, { Fragment } from "react";
import { useFormikContext } from "formik";
import { getFieldPath } from "utils/form";
import get from "lodash/get";
import SectionBezel from "components/SectionBezel";
import SegmentedControl from "components/SegmentedControl";
import { getStripeDestination } from "utils/stripe";
import SERVICES from "utils/constants/services";
import { TAX_BEHAVIOR_OPTIONS, TAX_CODE } from "utils/constants/taxRate";
import { UI_THEME } from "utils/constants/ui";
import Label from "components/Form/fields/Label";
import { useAppCheckout } from "utils/selectors";
import MultiSelect from "components/Form/fields/MultiSelect";
import TaxCodeOption from "components/TaxCodeOption";

const TaxFields = ({ name }) => {
  const {
    values,
    touched,
    setFieldTouched,
    setFieldValue
  } = useFormikContext();

  const idPath = getFieldPath(name, "id");
  const id = get(values, idPath);
  const editMode = Boolean(id);
  const checkout = useAppCheckout();

  const taxBehaviorPath = getFieldPath(name, "tax_behavior");
  const taxBehavior = get(values, taxBehaviorPath);
  const taxBehaviorTouched = get(touched, taxBehaviorPath);

  const segmentProps = {
    options: TAX_BEHAVIOR_OPTIONS,
    disabled: editMode,
    theme: UI_THEME.SLIM,
    value: taxBehavior,
    onClick: (_, selection) => {
      if (!taxBehaviorTouched) {
        setFieldTouched(taxBehaviorPath, true);
      }
      setFieldValue(taxBehaviorPath, selection);
    }
  };
  const taxCodes =
    checkout && checkout.taxCodes
      ? checkout.taxCodes.filter(
          ({ code }) => Object.values(TAX_CODE).indexOf(code) > -1
        )
      : [];

  const taxCodePath = getFieldPath(name, "tax_code");
  const taxCode = get(values, taxCodePath);
  const taxCodeOption =
    taxCodes && taxCodes.find(({ code }) => code === taxCode);
  const taxCodeTouched = get(touched, taxCodePath);
  let activeValue;
  if (taxCode && taxCodeOption) {
    activeValue = {
      id: taxCode,
      name: taxCodeOption && `${taxCodeOption.code} - ${taxCodeOption.name}`
    };
  }

  const multiselectProps = {
    value: activeValue ? [activeValue] : [],
    placeholder: "Select tax code",
    disabled: editMode,
    isMulti: false,
    options: [
      {
        id: "",
        label: "None",
        uid: "",
        description: ""
      },
      ...taxCodes.map(({ code, name, description }) => ({
        id: code,
        label: name,
        description,
        uid: code
      }))
    ],
    onChange: () => ({ value }) => {
      if (!taxCodeTouched) {
        setFieldTouched(taxCodePath, true);
      }

      setTimeout(() => setFieldValue(taxCodePath, value), 0);
    },
    labelTransform: (value) => value,
    components: {
      Option: TaxCodeOption
    }
  };

  return (
    <SectionBezel
      header="Tax"
      action={
        editMode
          ? {
              service: SERVICES.STRIPE,
              url: getStripeDestination({ path: `shipping-rates/${id}` })
            }
          : null
      }
    >
      <Fragment>
        <Label label="Tax behavior" />
        <div className="pv1">
          <SegmentedControl {...segmentProps} />
        </div>
        <div className="pt3">
          <Label label="Tax code" />
          <MultiSelect {...multiselectProps} />
        </div>
      </Fragment>
    </SectionBezel>
  );
};

export default TaxFields;
